export class TransformingDataFileVisitor {
    constructor(transformer) {
        this.transformer = transformer;
    }
    visitCompatibilityTable(doc) {
    }
    visitExternalFiled(doc) {
    }
    visitJsFilter(doc) {
    }
    visitOclConstraint(doc) {
    }
    visitOclFilter(doc) {
    }
    visitOption(doc) {
        this.transformer.preProcessOption(doc);
    }
    visitOptionGroup(doc) {
        this.transformer.preProcessOptionGroups(doc);
    }
    visitProduct(doc) {
        this.transformer.preProcessProduct(doc);
    }
    visitProductGroup(doc) {
    }
    visitUnknown(doc) {
    }
}
//# sourceMappingURL=TransformingDataFileVisitor.js.map